/* Ryse - Theoric: neutraliza o hero fixo SO depois que o conteudo o cobre 100%.
   PROBLEMA: hero-fullscreen-component e position:fixed e NUNCA sai da tela.
   O efeito de "o conteudo cobre o hero" so existe porque as sections seguintes
   ganham z-index:2 + fundo solido via seletor de irmao (.section-hero-spacer ~ .shopify-section).
   Consequencias: (a) qualquer coisa fora desse seletor (rodape, blocos de app) fica
   ATRAS do hero; (b) o <a class="hero-fullscreen__image-link"> (z-index 1000) rouba
   cliques da pagina inteira; (c) a camada fica sendo composta na GPU a rolagem toda.

   GATILHO — medido a cada rolagem, nao um numero fixo:
   o conteudo opaco comeca no fim do espacador. O hero so esta 100% coberto quando
   a BASE DO ESPACADOR passa acima do TOPO DO HERO. Nao da pra usar a altura do
   espacador como atalho: o tema troca --hero-offset de 32px pra 0px no meio da
   rolagem, entao o hero fica ~32px MAIS ALTO que o espacador e sobrava uma faixa
   dele aparecendo nas laterais do header (que e transparente ali).

   POR QUE NAO display:none — o proprio tema observa o hero pra decidir o
   --hero-offset e a classe body.scrolled-past-hero (que deixa o header opaco).
   Com display:none ele perde a referencia e o topo volta branco em vez de
   transparente sobre o banner. visibility:hidden mantem a caixa do elemento.

   Sem requestAnimationFrame de proposito: a checagem e uma leitura de retangulo e
   o rAF congela em abas de fundo. */
(function () {
  var CLASSE = 'tfx-hero-off';
  var FOLGA = 4;

  function iniciar() {
    var hero = document.querySelector('hero-fullscreen-component');
    if (!hero) return;
    if (getComputedStyle(hero).position !== 'fixed') return;

    var estilo = document.createElement('style');
    estilo.textContent =
      'body.' + CLASSE + ' hero-fullscreen-component{' +
      'visibility:hidden!important;pointer-events:none!important}';
    document.head.appendChild(estilo);

    var coberto = false;
    var topoDoHero = 0;

    function aplicar(v) {
      if (v === coberto) return;
      coberto = v;
      document.body.classList.toggle(CLASSE, v);
      var vids = hero.querySelectorAll('video');
      for (var i = 0; i < vids.length; i++) {
        if (v) {
          try { vids[i].pause(); } catch (e) {}
        } else {
          var p = vids[i].play();
          if (p && p.catch) p.catch(function () {});
        }
      }
    }

    function checar() {
      var sp = document.querySelector('.section-hero-spacer');
      if (!sp) return;

      /* o topo do hero so e confiavel enquanto ele esta visivel; guarda o ultimo bom */
      if (!coberto) topoDoHero = hero.getBoundingClientRect().top;

      /* base do espacador = onde o conteudo opaco comeca */
      var inicioDoConteudo = sp.getBoundingClientRect().bottom;

      aplicar(inicioDoConteudo <= topoDoHero - FOLGA);
    }

    /* 1 checagem por quadro (antes: a cada evento de rolagem, lendo 2 retangulos) */
    var fila = false;
    window.addEventListener('scroll', function () {
      if (fila) return;
      fila = true;
      requestAnimationFrame(function () { fila = false; checar(); });
    }, { passive: true });
    window.addEventListener('resize', function () {
      aplicar(false);
      checar();
    }, { passive: true });
    checar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();